import { UAParser } from "ua-parser-js";
import { v4 as uuidv4 } from "uuid";

export const initUUID = () => {
  const localUuid = localStorage.getItem("uuid");

  if (!localUuid) {
    localStorage.setItem("uuid", uuidv4());
  }
};

export const getDeviceInfo = () => {
  const parser = new UAParser();

  const deviceId = localStorage.getItem("uuid") || "";
  const deviceName = parser.getUA();

  return { deviceId, deviceName };
};

export function iOS() {
  const parser = new UAParser();
  return parser.getOS().name === "iOS";
}

export const deviceWidth = window.innerWidth;

export const showUIBasedOnDeviceWidth = (width: number) => deviceWidth >= width;

export const showUIBasedOnDeviceWidthLesser = (width: number) => deviceWidth < width;

export const showUIBasedOnDeviceWidthGreater = (width: number) => deviceWidth >= width;
